import { render, staticRenderFns } from "./Contained.vue?vue&type=template&id=3d28d1c1&scoped=true"
import script from "./Contained.vue?vue&type=script&lang=js"
export * from "./Contained.vue?vue&type=script&lang=js"
import style0 from "./Contained.vue?vue&type=style&index=0&id=3d28d1c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28d1c1",
  null
  
)

export default component.exports